import { render, staticRenderFns } from "./CMobileTabs.vue?vue&type=template&id=3ac3ee8e&scoped=true"
import script from "./CMobileTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CMobileTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CMobileTabs.vue?vue&type=style&index=0&id=3ac3ee8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3ee8e",
  null
  
)

export default component.exports